import Notification from "../../components/shared/Notification";
import request from "../../helpers/request";

export const getAllProvinces = async () => {
  try {
    const token = localStorage.getItem("token");

    return await request(token)
      .get("/address/provinces")
      .then(({ data }) => {
        if (data?.errorMessage || data?.errors || data?.error) {
          Notification(
            "Error",
            data?.errorMessage ||
              data?.errors ||
              "Something went wrong. Please check your information!",
            "error"
          );
        }
        return data;
      });
  } catch (error) {
    return Notification(
      "Error",
      error.response.data.message || "Some went wrong! Please try again later!",
      "error"
    );
  }
};

export const getAllRegions = async () => {
  try {
    const token = localStorage.getItem("token");

    return await request(token)
      .get("/address/regions")
      .then(({ data }) => {
        if (data?.errorMessage || data?.errors || data?.error) {
          Notification(
            "Error",
            data?.errorMessage ||
              data?.errors ||
              "Something went wrong. Please check your information!",
            "error"
          );
        }
        return data;
      });
  } catch (error) {
    return Notification(
      "Error",
      error.response.data.message || "Some went wrong! Please try again later!",
      "error"
    );
  }
};

export const getProvince = async (code) => {
  try {
    const token = localStorage.getItem("token");

    return await request(token)
      .get(`/address/region/${code}/provinces`)
      .then(({ data }) => {
        if (data?.errorMessage || data?.errors || data?.error) {
          Notification(
            "Error",
            data?.errorMessage ||
              data?.errors ||
              "Something went wrong. Please check your information!",
            "error"
          );
        }
        return data;
      });
  } catch (error) {
    return Notification(
      "Error",
      error.response.data.message || "Some went wrong! Please try again later!",
      "error"
    );
  }
};

export const getMunicipality = async (code) => {
  try {
    const token = localStorage.getItem("token");

    return await request(token)
      .get(`/address/province/${code}/municipalities`)
      .then(({ data }) => {
        if (data?.errorMessage || data?.errors || data?.error) {
          Notification(
            "Error",
            data?.errorMessage ||
              data?.errors ||
              "Something went wrong. Please check your information!",
            "error"
          );
        }
        return data;
      });
  } catch (error) {
    return Notification(
      "Error",
      error.response.data.message || "Some went wrong! Please try again later!",
      "error"
    );
  }
};

export const getBarangay = async (code) => {
  try {
    const token = localStorage.getItem("token");

    return await request(token)
      .get(`/address/municipality/${code}/barangays`)
      .then(({ data }) => {
        if (data?.errorMessage || data?.errors || data?.error) {
          Notification(
            "Error",
            data?.errorMessage ||
              data?.errors ||
              "Something went wrong. Please check your information!",
            "error"
          );
        }
        return data;
      });
  } catch (error) {
    return Notification(
      "Error",
      error.response.data.message || "Some went wrong! Please try again later!",
      "error"
    );
  }
};
